import { useCallback } from 'react';
import camelCase from 'lodash/camelCase';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { productsJswConfigurationResource } from '@atlassian/jira-router-resources-products-jsw-configuration';
import { useResource } from '@atlassian/react-resource-router';

export const useProductsJswConfigurationResource = () => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const { data, update, loading } = useResource<any>(productsJswConfigurationResource);
	return { data, update, loading };
};

export const useFeatures = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { data, update } = useProductsJswConfigurationResource();

	const updateFeature = useCallback(
		async (key: string, value: boolean) => {
			const url = `/rest/greenhopper/latest/jswfeature?features=${key}`;
			try {
				await performPostRequest(url, {
					body: JSON.stringify({
						featureKey: key,
						value,
					}),
				});

				// only fire analytic when the update was done successfully
				fireTrackAnalytics(createAnalyticsEvent({}), `${camelCase(key)}JswConfiguration updated`, {
					value,
				});
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				fireErrorAnalytics({
					error,
					meta: {
						id: 'productsJswConfig',
						packageName: 'jiraProductsJswConfigurationMain',
					},
				});
			}

			update((currentData) => ({
				...currentData,
				[key]: value,
			}));
		},
		[update, createAnalyticsEvent],
	);
	return { data, updateFeature };
};
